/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Geometry } from './Geometry';
import {
    GeometryFromJSON,
    GeometryFromJSONTyped,
    GeometryToJSON,
} from './Geometry';
import type { PolygonGeometry } from './PolygonGeometry';
import {
    PolygonGeometryFromJSON,
    PolygonGeometryFromJSONTyped,
    PolygonGeometryToJSON,
} from './PolygonGeometry';
import type { PortExtendedInnerInner } from './PortExtendedInnerInner';
import {
    PortExtendedInnerInnerFromJSON,
    PortExtendedInnerInnerFromJSONTyped,
    PortExtendedInnerInnerToJSON,
} from './PortExtendedInnerInner';
import type { Quay } from './Quay';
import {
    QuayFromJSON,
    QuayFromJSONTyped,
    QuayToJSON,
} from './Quay';

/**
 * 
 * @export
 * @interface PortExtended
 */
export interface PortExtended {
    /**
     * 
     * @type {number}
     * @memberof PortExtended
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PortExtended
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PortExtended
     */
    locode?: string;
    /**
     * 
     * @type {string}
     * @memberof PortExtended
     */
    name?: string;
    /**
     * 
     * @type {Geometry}
     * @memberof PortExtended
     */
    position?: Geometry;
    /**
     * 
     * @type {PolygonGeometry}
     * @memberof PortExtended
     */
    outer?: PolygonGeometry;
    /**
     * 
     * @type {Array<PortExtendedInnerInner>}
     * @memberof PortExtended
     */
    inner?: Array<PortExtendedInnerInner>;
    /**
     * 
     * @type {Array<Quay>}
     * @memberof PortExtended
     */
    quay?: Array<Quay>;
}

/**
 * Check if a given object implements the PortExtended interface.
 */
export function instanceOfPortExtended(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortExtendedFromJSON(json: any): PortExtended {
    return PortExtendedFromJSONTyped(json, false);
}

export function PortExtendedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortExtended {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'locode': !exists(json, 'locode') ? undefined : json['locode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'position': !exists(json, 'position') ? undefined : GeometryFromJSON(json['position']),
        'outer': !exists(json, 'outer') ? undefined : PolygonGeometryFromJSON(json['outer']),
        'inner': !exists(json, 'inner') ? undefined : ((json['inner'] as Array<any>).map(PortExtendedInnerInnerFromJSON)),
        'quay': !exists(json, 'quay') ? undefined : ((json['quay'] as Array<any>).map(QuayFromJSON)),
    };
}

export function PortExtendedToJSON(value?: PortExtended | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'country': value.country,
        'locode': value.locode,
        'name': value.name,
        'position': GeometryToJSON(value.position),
        'outer': PolygonGeometryToJSON(value.outer),
        'inner': value.inner === undefined ? undefined : ((value.inner as Array<any>).map(PortExtendedInnerInnerToJSON)),
        'quay': value.quay === undefined ? undefined : ((value.quay as Array<any>).map(QuayToJSON)),
    };
}

